export default __webpack_public_path__ + "static/media/whatsapp_icon.b52b84e9.png";